import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import deTranslations from './locales/de.json'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      de: {
        translation: deTranslations,
      },
    },
    lng: 'de',
    fallbackLng: 'de',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n

